import { Pipe, PipeTransform } from "@angular/core";
import * as moment from 'moment';
import { Constants } from '../../../app.constant';
const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';
const DEFAULT_INDIAN_DATE_FORMAT = 'DD-MM-YYYY';

@Pipe({
  name: 'dateFormatPipe'
})
export class DateFormatPipe implements PipeTransform {
  public dateFormate = Constants.Var.dateFormate;
  public timestampFormate = Constants.Var.timestampFormate; 

  transform(value: any, type?: string): string {
    if (!value) return null;
    //let inputFormat = 'YYYY-MM-DD';
    let result = null;
    let date = /^[0-9]+$/.test(value) ? moment(value) : moment(value, this.dateFormate);
    switch (type) {
      case "sort":
        if (moment().diff(date, 'days') > 1) {
          result = date.format('ll').split(',')[0];
        } else {
          result = (date.calendar().split(' ')[0] === "Last" ? date.calendar().split(' ')[1] : date.calendar().split(' ')[0]);
        }
        break;
      default:
        result = date.format(DEFAULT_DATE_FORMAT);
        break;
    }
    return result;
  }
}

@Pipe({
    name: 'datex'
})
export class DatexPipe implements PipeTransform {
  transform(value: string, format: string = ""): string {
    if (!value || value==="") return "";
    return moment(value).format(format);
  }
}

@Pipe({
  name: 'fileSizePipe'
})
export class FileSizePipe implements PipeTransform {

  transform(value: number): string {
    if (value) {
      const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      let l = 0, n = value;
      while (n >= 1024 && ++l)
        n = n / 1024;
      //return (n.toFixed(n >= 10 || l < 1 ? 0 : 1) + ' ' + units[l]);    
      return (Math.round(n*100)/100 + ' ' + units[l]);
      
    }
  }
}

@Pipe({
  name: 'indiandateFormatPipe'
})
export class IndianDateFormatPipe implements PipeTransform {
  public indiandateFormate = Constants.Var.indiandateFormate;
  public timestampFormate = Constants.Var.timestampFormate; 

  transform(value: any, type?: string): string {
    if (!value) return null;
    //let inputFormat = 'YYYY-MM-DD';
    let result = null;
    let date = /^[0-9]+$/.test(value) ? moment(value) : moment(value, this.indiandateFormate);
    switch (type) {
      case "sort":
        if (moment().diff(date, 'days') > 1) {
          result = date.format('ll').split(',')[0];
        } else {
          result = (date.calendar().split(' ')[0] === "Last" ? date.calendar().split(' ')[1] : date.calendar().split(' ')[0]);
        }
        break;
      default:
        result = date.format(DEFAULT_INDIAN_DATE_FORMAT);
        break;
    }
    return result;
  }
}


@Pipe({
  name: 'time'
})
export class Time implements PipeTransform {
  public indiandateFormate = Constants.Var.indiandateFormate;
  public timestampFormate = Constants.Var.timestampFormate; 

  transform(value: any, type?: string): string {
    if (!value) return null;
    let inputFormat = 'HH:mm';
    return moment(value, "x").format(inputFormat);
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/shared/pipes/date-format.pipe.ts